import styled from 'styled-components';

import { COLORS } from '../../../../utils/theme/colors';

const BORDER = '#d9d9d9';
const MUTED = 'rgba(0, 0, 0, 0.45)';

export const DoorLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .door-error,
  .door-error:hover,
  .door-error:focus {
    border-color: ${COLORS.red};
  }
`;

export const ConnectorBar = styled.div`
  width: 100%;
  margin-top: -12px;

  && .ant-tabs-top > .ant-tabs-nav {
    margin-bottom: 12px;
  }

  && .ant-tabs-tab {
    padding-top: 0;
  }
`;

export const StatusDot = styled.span<{ $on: boolean }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;
  background: ${({ $on }) => ($on ? COLORS.available : '#bfbfbf')};
`;

export const LinkButton = styled.button`
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  font-weight: 500;
  color: ${({ theme }) => theme.primary};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const EnableRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;

  .ant-switch-checked {
    background-color: ${({ theme }) => theme.primary};
  }

  .text {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0 12px;
  }

  .label {
    font-weight: 500;
  }

  .sub {
    color: ${MUTED};
    font-size: 12px;
  }
`;

// $single: método movE IoT, sem método HTTP/URL nem cabeçalhos
export const FieldsRow = styled.div<{ $single?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $single }) =>
    $single
      ? '220px minmax(0, 1fr) 120px'
      : '220px 140px minmax(0, 1fr) 120px'};
  gap: 0 24px;
  width: 100%;
`;

export const RequestRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0 24px;
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  margin-bottom: 12px;
`;

export const FieldError = styled.div`
  color: red;
  font-size: 12px;
  margin-top: 2px;
`;

export const FieldHelp = styled.div`
  color: ${MUTED};
  font-size: 12px;
  margin-top: 4px;

  code {
    font-size: 12px;
  }
`;

export const HeaderRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* 3,5 linhas de 40px + 8px de gap: a meia linha mostra que há mais */
  max-height: 164px;
  overflow-y: auto;

  .row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) 32px;
    gap: 8px;
  }

  .remove {
    border: 0;
    background: none;
    cursor: pointer;
    color: ${MUTED};

    &:hover {
      color: ${COLORS.red};
    }
  }
`;

export const BodyEditor = styled.div`
  textarea.ant-input {
    font-family: Menlo, Consolas, monospace;
    font-size: 13px;
    resize: none;
  }
`;

export const DoorActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 12px 16px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 3px;
  color: rgba(0, 0, 0, 0.65);

  .info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .k {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    margin-right: 6px;
  }

  .empty {
    color: ${MUTED};
  }

  .buttons {
    display: flex;
    gap: 12px;
    flex-shrink: 0;
  }

  .buttons .ant-btn:not([disabled]):hover,
  .buttons .ant-btn:not([disabled]):focus {
    color: ${({ theme }) => theme.primary};
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const AttemptText = styled.span<{ $tone: 'success' | 'error' }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $tone }) =>
      $tone === 'success' ? COLORS.available : COLORS.red};
  }

  .sub {
    color: ${MUTED};
  }
`;

export const HistoryList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    padding: 8px 0;
    border-bottom: 1px solid ${BORDER};
  }

  li:last-child {
    border-bottom: 0;
  }
`;
